/* eslint-disable react/jsx-no-useless-fragment */
import { Divider, Stack } from '@mui/material';
import { useMemo, useState } from 'react';
import { EditPanel } from '@/modules/simulation/components/EditPanel';
import { ListPanel } from '@/modules/simulation/components/ListPanel/ListPanel';
import { SimulationGroup } from '@thive/fddm-types';
import { SimulationServiceFactory } from '@/modules/simulation/service/SimulationServiceFactory';
import { GroupPanel } from '@/modules/simulation/components/GroupPanel';

export function SimulationPanel() {
  const simSvc = useMemo(
    () => SimulationServiceFactory.getInstance().createSimulationService(),
    [],
  );

  const [view, setView] = useState<'list' | 'edit' | 'details'>('list');
  const [simulationGroup, setSimulationGroup] = useState<SimulationGroup>();

  const onCloseEditPanel = () => {
    setSimulationGroup(undefined);
    setView('list');
  };

  const onShowDetailPanel = async (simulationGroup: SimulationGroup) => {
    setSimulationGroup(simulationGroup);
    setView('details');
  };

  const onCloseDetailPanel = async () => {
    setSimulationGroup(undefined);
    setView('list');
  };

  const onAddSimulationGroup = async (name: string) => {
    simSvc.createDraft(name);
    setView('edit');
  };

  const onEditSimulationGroup = async (record: SimulationGroup, name: string) => {
    simSvc.createDraftFromRecord(record, name);
    setView('edit');
  };

  return (
    <Stack height='100%' data-testid='SimulationPanel' divider={<Divider />} sx={{ pt: 1 }}>
      {view === 'edit' && <EditPanel onClosePanel={onCloseEditPanel} />}
      {view === 'list' && (
        <ListPanel
          onShowDetails={onShowDetailPanel}
          onAddSimulationGroup={onAddSimulationGroup}
          onEditSimulationGroup={onEditSimulationGroup}
        />
      )}
      {view === 'details' && simulationGroup && (
        <GroupPanel
          group={simulationGroup}
          onEditSimulationGroup={onEditSimulationGroup}
          onClose={onCloseDetailPanel}
        />
      )}
    </Stack>
  );
}
